<template>
  <!-- <f7-page class=""> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
      <page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Settings" :menuAccess="true"></page-nav-bar>
      <div class="layoutTop"/>
      <div class="container-fluid">

      <div class="settingBetweenList"/>
      <div class="list-block">
        <ul>
          <li v-if="serviceName === 'Payments' || serviceName === ''">
            <a href="/settings/application/" class="item-link item-content">
              <div class="item-inner">
                <div class="item-title">{{ $t('settings.applctn_sttngs') }}</div>
              </div>
            </a>
          </li>
          <li v-else-if="serviceName === 'Direct Debit'">
            <a href="/settings/directDebit/" class="item-link item-content">
              <div class="item-inner">
                <div class="item-title">{{ $t('settings.applctn_sttngs') }}</div>
              </div>
            </a>
          </li>
          <li v-else-if="serviceName === 'Direct Payments'">
            <a href="/settings/directPayments/" class="item-link item-content">
              <div class="item-inner">
                <div class="item-title">{{ $t('settings.applctn_sttngs') }}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="/settings/remind/" class="item-link item-content">
              <div class="item-inner">
                <div class="item-title">Remind Settings</div>
              </div>
            </a>
          </li>

        </ul>
      </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>
// import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      serviceName: ''
    }
  },
  created: function () {
    let that = this
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    that.serviceName = this.$engine.user.currentService.name
    if (!that.serviceName) {
      that.serviceName = ''
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// CMSettingPage.vue?565c9564